<template>
  <div>
    <span :class="isMobile?'png-icon-icons-glyph--ko-heart':'png-icon-icons-glyph--k-heart'" class="png-icon cursor-pointer float-right" @click="addToProject()"></span>

    <modal
      height="650"
      :name="'project-wizard-webPage-content-modal-' + dynamicId"
      data-html2canvas-ignore="true"
      :adaptive="true"
      class="my-project-modal"
      :scrollable="true"
    >
      <pc-project-wizard-content-modal :isMobile="isMobile" @closeModal="closeModal($event)"></pc-project-wizard-content-modal>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ContentItemTypes, step1Data } from "../../../stepTree";
import PcProjectWizardContentModal from "../content-wizard-modal/pc-project-wizard-content-modal.vue";
import commonMethods from "../../../scripts/common-methods";

export default {
  props:['isMobile'],
  components: {
    PcProjectWizardContentModal,
  },
  computed: {
    ...mapGetters({
      productData: "productDetail/productData",
      selectedProduct: "productDetail/selectedProduct",
      userIsAuthenticated: "contentWizard/getuserIsAuthenticated",
      getproductSearchResponse: "contentWizard/getproductSearchResponse",
    })
  },
  data() {
    return {
      dynamicId: null
    };
  },


  beforeDestroy(){
    this.handleZindex(1024);
  },

  mounted(){
    this.openModalIfLoggedIn();
    this.dynamicId = this._uid;
  },

  methods: {
    ...mapActions({
      setStep1: "contentWizard/setStep1",
      setStep: "contentWizard/setStep",
      setContentType: "contentWizard/setContentType",
      setContentItem: "contentWizard/setContentItem",
      updatId: "contentWizard/updateselectedTrayId",
      setIsOutOfProject: "contentWizard/setIsOutOfProject",
      resetContent: "contentWizard/resetContent",
      resetContentType: "contentWizard/resetContentType",
      GetPageUrl: "contentWizard/GetPageUrl",
      updateProductSearchTerm: "contentWizard/updateProductSearchTerm",
      setSelectedProduct: "contentWizard/selectedProduct",
      setIsStep2ItemSelected: "contentWizard/setIsStep2ItemSelected",
      fetchproductSearch: "contentWizard/fetchproductSearch",
    }),

    handleZindex(value){
      let element = document.querySelector('.sticky-top');
      if(element){
        element.style.zIndex = value;
      }
    },

    closeModal(){
      this.$modal.hide("project-wizard-webPage-content-modal-" + this.dynamicId);
      this.handleZindex(1);
    },

    async addToProject() {
      if (this.userIsAuthenticated === "true" || this.userIsAuthenticated === true)
      {
        if(document.getElementById('pageTypeForProject') && document.getElementById('pageTypeForProject').value == 'pdp' && document.getElementById('sellingStyleNumberForProject') && document.getElementById('sellingStyleNumberForProject').value != '')
        {
          const sellingStyleNumber = document.getElementById('sellingStyleNumberForProject').value;
          const inventoryType = document.getElementById('inventoryTypeForProject').value;
          const sellingStyleName = document.getElementById('sellingStyleNameForProject').value;
          this.$modal.show("project-wizard-webPage-content-modal-" + this.dynamicId);
          document.getElementById("product-room-scene-colors").style.zIndex = 1;

          // Set content wizard type
          this.setIsOutOfProject(true);

          // Reset Content Wizard State
          this.resetContentType();
          this.resetContent();

          // Set Content Wizard New Data
          this.setContentItem({
            productType: inventoryType,
            productId: sellingStyleNumber,
            productInventoryType: inventoryType,
            title:
              sellingStyleName,
            productTitle:
              sellingStyleName + " - " + sellingStyleNumber,
            selectedProduct:
              sellingStyleName + " - " + sellingStyleNumber,
            coverPhoto: null,
            thumbnailUrl: null,
            type: ContentItemTypes.product,
            size: 0
          });

          // Set step data
          this.setStep(2);
          this.setContentType(step1Data.product.defaultType);
          this.setStep1({ selectedType: "product" });

          // Set product data
          await this.updateProductSearchTerm(this.productData.inventoryType);
          this.setIsStep2ItemSelected(false);
          await this.fetchproductSearch().then(() => {
            this.getSelectedProductFromArr(sellingStyleNumber);
            this.setIsStep2ItemSelected(true);
            this.setContentItem({
              isItemSelected: true
            });
          });
        }
        else{
          this.handleZindex(1);
          const path = window.location?.pathname;
          if(path){
            this.GetPageUrl(path);
          }
          this.$modal.show("project-wizard-webPage-content-modal-" + this.dynamicId);
          // Reset Content Wizard State
          this.resetContentType();
          this.resetContent();

          // Set content wizard type
          this.setIsOutOfProject(true);

          // Set step data
          this.setStep(2);
          this.setContentType(step1Data.webPage.defaultType);
          this.setStep1({ selectedType: "webPage" });

          // Set Content Wizard New Data
          this.setContentItem({
            type: ContentItemTypes.webPage,
          });
        }
      } else {
        commonMethods.fallBackURL('webpage');
      }
    },

    getSelectedProductFromArr(styleNumber) {
      if (this.getproductSearchResponse.items.length > 0) {
        this.getproductSearchResponse.items.forEach(item => {
          if (item.styleNumber.toLowerCase() == styleNumber.toLowerCase())
            this.setSelectedProduct(item);
        });
      } else {
        return [];
      }
    },

    openModalIfLoggedIn() {
      const urlParams = new URLSearchParams(window.location.search);
      const hash = window.location.hash;
      // Check if openModal parameter exists in query string
      if (
        urlParams.has("openModal") &&
        urlParams.get("openModal") === "webpage"
      ) {
        this.addToProject();
        setTimeout(()=>{
          commonMethods.removeQueryParam();
          this.handleZindex(1);
        },2000)
        return;
      }
      // Check if openModal parameter exists in fragment identifier
      const hashParams = new URLSearchParams(hash.substring(1));
      if (
        hashParams.has("openModal") &&
        hashParams.get("openModal") === "webpage"
      ) {
        this.addToProject();
      }
    },


  },
};
</script>
